import * as actionTypes from "../actionTypes";

const initialState = {
  origins: [],
  inactiveOrigins: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_ORIGINS:
      return {
        ...state,
        origins: action.payload,
      };
    case actionTypes.SET_INACTIVE_ORIGINS:
      return {
        ...state,
        inactiveOrigins: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
